import DTO from './DTO';

class LocationDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'vehicle_external_id',
        type: String,
        validators: [],
        labelKey: 'vehicle.external_id',
      },
      {
        name: 'vehicle_terminal_id',
        type: String,
        validators: [],
        labelKey: 'vehicle_terminal_id',
      },
      {
        name: 'vehicle_datetime_at',
        type: String,
        validators: [],
        labelKey: 'vehicle_datetime_at',
      },
      {
        name: 'vehicle_latitude',
        type: String,
        validators: [],
        labelKey: 'latitude',
      },
      {
        name: 'vehicle_longitude',
        type: String,
        validators: [],
        labelKey: 'longitude',
      },
      {
        name: 'vehicle_speed',
        type: String,
        validators: [],
        labelKey: 'vehicle_speed',
      },
      {
        name: 'vehicle_travel_angle',
        type: String,
        validators: [],
        labelKey: 'vehicle_travel_angle',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default LocationDTO;
